var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSendMessage = function SvgSendMessage(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.0009 7.99166C14.002 8.39809 13.7828 8.77321 13.4282 8.97185L1.67146 15.6939C1.50276 15.7895 1.31228 15.8401 1.11836 15.8409C0.347852 15.8368 -0.188542 15.074 0.0681455 14.3475L1.95852 8.74991C1.99638 8.63777 2.10064 8.56154 2.21898 8.55947H7.27958C7.60401 8.56018 7.86118 8.28597 7.83969 7.96225C7.81335 7.66351 7.56125 7.43553 7.26138 7.43925H2.22038C2.10023 7.43926 1.99347 7.36263 1.95502 7.24881L0.0646455 1.6519C-0.220754 0.838152 0.481777 0.0205958 1.3292 0.180302C1.44775 0.202646 1.56191 0.24399 1.66726 0.302733L13.4296 7.01636C13.7821 7.21451 14.0005 7.58727 14.0009 7.99166Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSendMessage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "send-message.b69bfdd4b8b8eaf4be594460e7c9591b.svg";